/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'padded',
    quality: 0.15,
    toughness: 1,
    armorClass: 1
}